"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lib = require("../../lib");
var _react = _interopRequireDefault(require("react"));
var _dropdownModule = _interopRequireDefault(require("./dropdown.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ArcDropdown = function ArcDropdown(_ref) {
  var icon = _ref.icon,
    menuitems = _ref.menuitems,
    placement = _ref.placement,
    arrow = _ref.arrow,
    Click = _ref.Click,
    title = _ref.title,
    onclick = _ref.onclick,
    onVisibleChange = _ref.onVisibleChange,
    visible = _ref.visible,
    isbtnDrpdwn = _ref.isbtnDrpdwn,
    disabled = _ref.disabled;
  var menu = /*#__PURE__*/_react["default"].createElement("div", {
    className: _dropdownModule["default"].menuWrapper
  }, /*#__PURE__*/_react["default"].createElement(_lib.Menu, {
    items: menuitems,
    onClick: onclick && onclick
  }));
  return !isbtnDrpdwn ? visible ? /*#__PURE__*/_react["default"].createElement(_lib.Dropdown, {
    overlay: menu,
    placement: placement && placement,
    arrow: arrow && arrow,
    trigger: Click,
    onVisibleChange: onVisibleChange && onVisibleChange,
    visible: visible && visible
    // getPopupContainer={trigger => trigger.parentNode}
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, title), /*#__PURE__*/_react["default"].createElement("span", null, icon))) : /*#__PURE__*/_react["default"].createElement(_lib.Dropdown, {
    overlay: menu,
    placement: placement && placement,
    arrow: arrow && arrow,
    trigger: Click
    // getPopupContainer={trigger => trigger.parentNode}
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, title), /*#__PURE__*/_react["default"].createElement("span", null, icon))) : /*#__PURE__*/_react["default"].createElement(_lib.Dropdown.Button, {
    onClick: onclick && onclick,
    overlay: menu,
    icon: icon && icon,
    disabled: disabled && disabled
    // getPopupContainer={trigger => trigger.parentNode}
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, title)));
};
var _default = ArcDropdown;
exports["default"] = _default;